import { render, staticRenderFns } from "./DeActivatedBot.vue?vue&type=template&id=12f24f96&scoped=true&"
import script from "./DeActivatedBot.vue?vue&type=script&lang=js&"
export * from "./DeActivatedBot.vue?vue&type=script&lang=js&"
import style0 from "./DeActivatedBot.vue?vue&type=style&index=0&id=12f24f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f24f96",
  null
  
)

export default component.exports